export const environment = {
    production: true,
};

export const BASE_URL = 'https://mobile-api.hdz.hr/stranka_api/v1.0/';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/environments/environment.ts